import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ confirm, onClose }) => {
  const handleConfirm = () => {
    onClose(confirm.id, true);
  };

  const handleCancel = () => {
    onClose(confirm.id, false);
  };

  const getIcon = () => {
    switch (confirm.type) {
      case 'danger':
        return '⚠️';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '?';
    }
  };

  return (
    <div className="confirm-overlay">
      <div className={`confirm-dialog confirm-${confirm.type || 'default'}`}>
        <div className="confirm-icon-container">
          <div className={`confirm-icon confirm-icon-${confirm.type || 'default'}`}>
            {getIcon()}
          </div>
        </div>

        <div className="confirm-content">
          {confirm.title && (
            <h3 className="confirm-title">{confirm.title}</h3>
          )}
          <p className="confirm-message">{confirm.message}</p>
        </div>

        <div className="confirm-footer">
          <button
            type="button"
            className="confirm-button confirm-button-cancel"
            onClick={handleCancel}
          >
            {confirm.cancelText || 'Annuler'}
          </button>
          <button
            type="button"
            className={`confirm-button confirm-button-confirm confirm-button-${confirm.type || 'default'}`}
            onClick={handleConfirm}
          >
            {confirm.confirmText || 'Confirmer'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
